// extracted by mini-css-extract-plugin
module.exports = {"appPagination":"Pagination_appPagination__26TuP","paginationItem":"Pagination_paginationItem__233Uv","paginationItemActive":"Pagination_paginationItemActive__1LiiD"};